// extracted by mini-css-extract-plugin
export default {"root":"ContainerInfoWorkflow_root__ar4VS","task":"ContainerInfoWorkflow_task__X-PAN","info":"ContainerInfoWorkflow_info__z-H4A"};